import { render, staticRenderFns } from "./SwitchStudentToGroupDialog.vue?vue&type=template&id=78c03bec&scoped=true"
import script from "./SwitchStudentToGroupDialog.vue?vue&type=script&lang=js"
export * from "./SwitchStudentToGroupDialog.vue?vue&type=script&lang=js"
import style0 from "./SwitchStudentToGroupDialog.vue?vue&type=style&index=0&id=78c03bec&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78c03bec",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('78c03bec')) {
      api.createRecord('78c03bec', component.options)
    } else {
      api.reload('78c03bec', component.options)
    }
    module.hot.accept("./SwitchStudentToGroupDialog.vue?vue&type=template&id=78c03bec&scoped=true", function () {
      api.rerender('78c03bec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/student/StudentGroupDialog/SwitchStudentToGroupDialog.vue"
export default component.exports